import { array, Decoder, object, string } from '@mojotech/json-type-validation'

import { CommentaryInfo } from '@/domain/value_objects/commentary/CommentaryInfo'

export const commentaryInfoDecoder: Decoder<CommentaryInfo> = object({
  type: string(),
  pattern: string(),
  filter: array(string())
})
